import { render, staticRenderFns } from "./virtualCard.vue?vue&type=template&id=31eaf8b0&scoped=true&"
import script from "./virtualCard.vue?vue&type=script&lang=js&"
export * from "./virtualCard.vue?vue&type=script&lang=js&"
import style0 from "./virtualCard.vue?vue&type=style&index=0&id=31eaf8b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eaf8b0",
  null
  
)

export default component.exports